export const YOUTUBE_URL = "https://www.youtube.com/@ForeTheHellOfIt";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1605144884374-ecbb643615f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxnb2xmJTIwY291cnNlJTIwZHJvbmV8ZW58MHx8fHwxNzg4MTE0MzM4fDA&ixlib=rb-4.1.0&q=80&w=1600&auto=format",
  vlog: "https://images.unsplash.com/photo-1605144156683-5ebde77feed5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxnb2xmJTIwY291cnNlJTIwZHJvbmV8ZW58MHx8fHwxNzg4MTE0MzM4fDA&ixlib=rb-4.1.0&q=80&w=1000&auto=format",
  interview: "https://images.pexels.com/photos/33923596/pexels-photo-33923596.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  business: "https://images.pexels.com/photos/33923588/pexels-photo-33923588.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  travel: "https://images.unsplash.com/photo-1475070929565-c985b496cb9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxnb2xmZXIlMjBkYXJrJTIwbW9vZHl8ZW58MHx8fHwxNzg4MTE0MzM5fDA&ixlib=rb-4.1.0&q=80&w=1000&auto=format",
  podcast: "https://images.unsplash.com/photo-1660631228116-b3643559f611?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxwb2RjYXN0JTIwaW50ZXJ2aWV3JTIwbWljcm9waG9uZXxlbnwwfHx8fDE3ODgxMTQzMzl8MA&ixlib=rb-4.1.0&q=80&w=1000&auto=format",
  walking: "https://images.pexels.com/photos/5644637/pexels-photo-5644637.jpeg?auto=compress&cs=tinysrgb&w=1600&h=1000&fit=crop",
};

export const MANIFESTO = [
  {
    n: "01",
    title: "The Setting",
    body: "Golf is the setting. The people are the story.",
  },
  {
    n: "02",
    title: "The Round",
    body: "Every round gives us a few hours with someone worth getting to know.",
  },
  {
    n: "03",
    title: "No Studio. No Desk.",
    body: "No scripted interview — just golf, conversation, competition, laughs, and whatever happens along the way.",
  },
  {
    n: "04",
    title: "The Bar",
    body: "You don't have to be a great golfer to play with us. Neither are we.",
  },
];

export const CATEGORIES = [
  { slug: "guest-rounds", name: "Guest Rounds", desc: "Full rounds with interesting guests and conversations that unfold naturally throughout the course.", image: IMAGES.interview },
  { slug: "fore-shorts", name: "Fore Shorts", desc: "The best shots, worst shots, funniest moments, stories, and conversations from Fore.", image: IMAGES.vlog },
  { slug: "challenges", name: "Challenges", desc: "Competitions, games, challenges, and questionable decisions on the golf course.", image: IMAGES.hero },
  { slug: "on-the-road", name: "Fore On The Road", desc: "Courses, events, destinations, tournaments, and experiences away from our home turf.", image: IMAGES.travel },
];

export const PACKAGES = [
  {
    name: "Episode Partner",
    price: "Per Episode",
    featured: true,
    items: [
      "Featured partner of the full episode",
      "Host-read brand integration",
      "Brand integration throughout the episode",
      "Small sponsor logo on episode thumbnail",
      "Link in episode description",
      "Inclusion in supporting social content",
    ],
  },
  {
    name: "Front 9 Sponsor",
    price: "Per Episode",
    featured: false,
    items: [
      "Presenting sponsor of the Front 9",
      "Opening Front 9 sponsor recognition",
      "Natural brand/product integration",
      "On-screen sponsor recognition",
      "Link in episode description",
      "Inclusion in applicable Front 9 social content",
    ],
  },
  {
    name: "Back 9 Sponsor",
    price: "Per Episode",
    featured: false,
    items: [
      "Presenting sponsor of the Back 9",
      "Opening Back 9 sponsor recognition",
      "Natural brand/product integration",
      "On-screen sponsor recognition",
      "Link in episode description",
      "Inclusion in applicable Back 9 social content",
    ],
  },
  {
    name: "19th Hole Sponsor",
    price: "Per Episode",
    featured: false,
    items: [
      "Presenting sponsor of the 19th Hole",
      "Post-round brand integration",
      "On-screen sponsor recognition",
      "Link in episode description",
      "Inclusion in applicable 19th Hole social content",
    ],
  },
  {
    name: "General Sponsor",
    price: "Custom",
    featured: false,
    items: [
      "Flexible brand integration",
      "Long-term partnership opportunities",
      "Social and digital content opportunities",
      "Events and tournament opportunities",
      "Giveaways and collaborations",
      "Custom activations built around the brand",
    ],
  },
];

// Available sponsorship CONCEPTS — not existing sponsors. Never add a company name/logo
// here unless Fore has confirmed that partnership publicly.
export const SPONSOR_MOMENTS = [
  { name: "Episode Partner", desc: "Become the featured partner of a full Fore guest episode with prominent brand integration throughout the experience." },
  { name: "Front 9 Partner", desc: "Own the opening nine with brand integration and exposure throughout the Front 9." },
  { name: "Back 9 Partner", desc: "Own the second half of the round with brand integration and exposure throughout the Back 9." },
  { name: "19th Hole Partner", desc: "Own the post-round experience and conversation after the final hole." },
  { name: "General Partnership", desc: "Flexible partnership opportunities across Fore content, social media, products, events, experiences, and long-term brand collaborations." },
];

// COMING TO FORE — hidden until Fore provides confirmed, approved guests.
// Only add entries with: real approved photo, name, short descriptor. The section
// renders nothing while this list is empty.
export const UPCOMING_GUESTS = [];

export const INQUIRY_OPTIONS = [
  { value: "general", label: "General" },
  { value: "sponsorship", label: "Sponsorship" },
  { value: "partnership", label: "Partnership" },
  { value: "guest", label: "Become a Guest" },
  { value: "event", label: "Event / Outing" },
];

export const MARQUEE_ITEMS = ["Guest Rounds", "Fore Shorts", "Challenges", "On The Road", "Real Conversations", "Questionable Golf"];
